import _get from "lodash/get";

// ponytail: hardcoded list, move to event.settings.virtualRun.noEcer if it grows
const NO_ECER_EVENT_IDS = [
  "6a4d9cc9e70218a86d08e713",
  "6a60c9d9b9464500402dce20",
];

export const isNoEcer = (event) =>
  NO_ECER_EVENT_IDS.includes(String(_get(event, "_id"))) ||
  Boolean(_get(event, "settings.virtualRun.noEcer"));

export default isNoEcer;
